import { getIconBaseProps } from './utils';

export const threeRowLayout = {
  ...getIconBaseProps('threeRowLayout'),
  width: '20px',
  height: '20px',
  viewBox: '0 0 20 20',
  body: (
    <>
      <rect width='6' height='20' rx='1' fill='#C3CBD1' />
      <rect x='7' width='6' height='20' rx='1' fill='#C3CBD1' />
      <rect x='14' width='6' height='20' rx='1' fill='#C3CBD1' />
    </>
  ),
};
